import { Skeleton, Stack, Typography } from "@mui/material";
import StatusBadge from "components/common/StatusBadgeV2";

const Header = ({ config, status, ActionItems }) => (
  <Stack
    direction={"row"}
    justifyContent={"space-between"}
    alignItems={"center"}
    marginBottom={3}
    sx={{
      position: "sticky",
      top: "49px",
      margin: "-1rem -1rem 2rem -1rem",
      padding: "1rem",
      borderTopLeftRadius: "0.25rem",
      borderTopRightRadius: "0.25rem",
      background: config?.background,
      zIndex: 999,
    }}
  >
    <Stack direction={"row"} alignItems={"center"} gap={1}>
      {config?.title ? (
        <Typography variant={"h6"} color={config?.color}>
          {config?.title}
        </Typography>
      ) : (
        <Skeleton width={"12rem"} height={40} />
      )}
      {status != null && <StatusBadge status={status} variant={"chip"} />}
    </Stack>
    {ActionItems}
  </Stack>
);

export default Header;
